module.exports = __webpack_public_path__ + "static/media/logo-dark.359487a3.svg";